import React from 'react';
import {StyleSheet, View, Image} from 'react-native';
import logger from '../../utils/logger';
import {appBackgroundWhiteBG} from '../../utils/utils';

const GenerateQRCode = props => {
   const qrCodeValue = props.valueStr;
   logger('String for QR Encoding::' + qrCodeValue);

   return (
      <View style={styles.container}>
         <View style={styles.card}>
            <Image
               source={{
                  uri: 'data:image/jpeg;base64,' + qrCodeValue,
               }}
               style={{height: 250, width: 250}}
            />
         </View>
      </View>
   );
};
const styles = StyleSheet.create({
   container: {flex: 1, justifyContent: 'center', alignItems: 'center'},
   card: {
      elevation: 3,
      backgroundColor: appBackgroundWhiteBG,
      shadowOffset: {width: 0, height: 1},
      shadowColor: '#333',
      shadowOpacity: 0.3,
      shadowRadius: 2,
      minHeight: 264,
      minWidth: 264,
      justifyContent: 'center',
      alignItems: 'center',
   },
});
export default GenerateQRCode;
